import React from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  NotFound,
  TutorDashboard,
  Applications,
  Signin,
  EducatorSignin,
  EducatorSignup,
  Signup,
  EmailVerification,
  ForgotPassword,
  ResetPassword,
  TutorOnboarding,
  StudentProfile,
  StudentTuition,
  StudentCountry,
  LearnerDashboard,
  InterviewConfirmation,
  StudentBookTuition,
  Checkout,
  OrderConfirmation,
  Tuitions,
  WaitingRoom,
  Whiteboard,
  ChatRoom,
  ChatMessaging,
  ChatWorkSheet,
  BankTransferConfirmation,
  PaymentLinkShare,
  Home,
  AdminDashboard,
  AdminTutors,
  K12,
  TutorPrivateTuition,
  TutorPerformance,
  TutorPayments,
  LessonQuestionnaire,
  ClassQuestionnaire,
  Lesson,
} from '../pages';

import { webPaths } from './paths';
import { ProtectedRoute } from '../components/ProtectedRoute';

export default function WebRoute() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path={webPaths.root} element={<Home />} />
      <Route path={webPaths.signin} element={<Signin />} />
      <Route path={webPaths.signup} element={<Signup />} />
      <Route path={webPaths.teachSignin} element={<EducatorSignin />} />
      <Route path={webPaths.teachSignup} element={<EducatorSignup />} />
      <Route path={webPaths.forgotPassword} element={<ForgotPassword />} />
      <Route path={`${webPaths.resetPassword}/:token`} element={<ResetPassword />} />
      <Route path={`${webPaths.emailVerification}/:token`} element={<EmailVerification />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route path={webPaths.tutorOnboarding} element={<TutorOnboarding />} />
        <Route path={webPaths.tutorDashboard} element={<TutorDashboard />} />
        <Route path={webPaths.tutork12} element={<K12 />} />
        <Route path={`${webPaths.tutorLesson}/:slug`} element={<Lesson />} />
        <Route path={webPaths.tutorPrivateTuition} element={<TutorPrivateTuition />} />
        <Route path={webPaths.tutorPerformance} element={<TutorPerformance />} />
        <Route path={webPaths.tutorPayments} element={<TutorPayments />} />

        <Route path={webPaths.adminDashboard} element={<AdminDashboard />} />
        <Route path={webPaths.adminTutors} element={<AdminTutors />} />
        <Route path={webPaths.applications} element={<Applications />} />
        <Route
          path={`${webPaths.interviewConfirmation}/:correlationId`}
          element={<InterviewConfirmation />}
        />

        <Route path={webPaths.studentTuitions} element={<Tuitions />} />
        <Route path={webPaths.tutorTuitions} element={<Tuitions />} />
        <Route path={webPaths.whiteboard} element={<Whiteboard />} />
        <Route path={`${webPaths.waitingRoom}/:lessonId`} element={<WaitingRoom />} />
        <Route path={`${webPaths.chatRoom}/:lessonId`} element={<ChatRoom />} />
        <Route path={webPaths.chatMessaging} element={<ChatMessaging />} />
        <Route path={webPaths.chatWorkSheet} element={<ChatWorkSheet />} />

        <Route path={webPaths.studentBookTuition} element={<StudentBookTuition />} />
        <Route path={webPaths.classQuestionnaire} element={<ClassQuestionnaire />} />
        <Route
          path={`${webPaths.lessonQuestionnaire}/:productEventId`}
          element={<LessonQuestionnaire />}
        />
        <Route path={webPaths.studentProfile} element={<StudentProfile />} />
        <Route path={webPaths.studentTuition} element={<StudentTuition />} />
        <Route path={webPaths.studentCountry} element={<StudentCountry />} />
        <Route path={webPaths.learnerDashboard} element={<LearnerDashboard />} />

        <Route path={webPaths.checkout} element={<Checkout />} />
        <Route path={webPaths.orderConfirmation} element={<OrderConfirmation />} />
        <Route path={webPaths.paymentLink} element={<PaymentLinkShare />} />
        <Route path={webPaths.bankTranserConfirmation} element={<BankTransferConfirmation />} />
      </Route>

      <Route path='*' element={<NotFound />} />
    </Routes>
  );
}
